import { render, staticRenderFns } from "./examinationForm.vue?vue&type=template&id=1133ceaa"
import script from "./examinationForm.vue?vue&type=script&lang=js"
export * from "./examinationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports